<template>
  <page>
    <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <div class="text-right ma-2" v-if="propMode === 'Convert'">
              <v-btn color="primary" @click.native="doConvert" v-if="tabMenu === 0 && checkAccess([permissionKeys.perm_016035])">
                <span>Convert</span>
                <v-icon right dark>mdi-arrow-right-bold</v-icon>
              </v-btn>
              <confirm v-model="promptConvert" @ok="proceedConvert">
                Are you sure you want to convert proposal no. - {{ this.propInfo.propNo }}?
              </confirm>
            </div>
            <div class="text-right ma-2" v-else>
              <v-btn color="primary" @click.native="doPrint" v-if="tabMenu === 0">
                <span>Print Proposal</span>
                <v-icon right dark>mdi-printer</v-icon>
              </v-btn>
            </div>
            <v-card>
              <v-tabs v-model="tabMenu">
                <v-tab ripple :key="1">{{ labels.propDetails }}</v-tab>
                <v-tab ripple :key="2">{{ labels.coverDetails }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabMenu" touchless>
                <v-tab-item :key="1" :transition="false" :reverse-transition="false">
                  <v-card :loading="loading">
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs12 md12 lg12>
                            <ProposalDetails ref="proposalDetails"></ProposalDetails>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item :key="2" :transition="false" :reverse-transition="false">
                  <v-card :loading="loading">
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs12 md12 lg12>
                            <CoverageDetails></CoverageDetails>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="submitting" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ submitMsg }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInfoDialog" width="600px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-content-copy</v-icon>
          <v-toolbar-title>Convert Proposal to Policy</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs1 md1 lg1> </v-flex>
              <v-flex xs1 md1 lg1>
                <v-icon>mdi-information</v-icon>
              </v-flex>
              <v-flex xs5 md5 lg5> Proposal converted to Policy No.(s): </v-flex>
              <v-flex xs5 md5 lg5>
                {{ polNo1 }}
              </v-flex>
              <v-flex xs7 md7 lg7> </v-flex>
              <v-flex xs5 md5 lg5>
                {{ polNo2 }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="doCancel">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import ProposalDetails from './ProposalDetails'
import CoverageDetails from './CoverageDetails'
import clone from 'clone'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import { permissionKeys } from '@/mixins/global/permissionKey'
export default {
  data() {
    return {
      permissionKeys: permissionKeys,
      tabMenu: undefined,
      loading: false,
      labels: {
        propDetails: 'Proposal Details',
        coverDetails: 'Coverage Details'
      },
      dto: {
        propNo: null,
        ipcNo: null,
        ipcSeqNo: null,
        propType: null,
        format: null,
        customName: null,
        sendEmail: null
      },
      promptConvert: undefined,
      submitting: false,
      showErrorDialog: false,
      submitMsg: undefined,
      convertForm: {
        propNo: null,
        ipcNo: null,
        ipcSeqNo: null,
        propType: null,
        polType: null,
        scheme: null,
        planNo: null
      },
      showInfoDialog: false,
      polNo1: '',
      polNo2: ''
    }
  },
  methods: {
    async doPrint() {
      if (this.propMode === 'Query') {
        let apiURI = this.$store.state.proposal.menu.export
        if (apiURI) {
          try {
            this.dto.propNo = this.propInfo.propNo
            this.dto.ipcNo = this.propInfo.ipcNo
            this.dto.ipcSeqNo = this.propInfo.ipcSeqNo
            this.dto.propType = this.propInfo.propType
            this.dto.format = 'PDF'
            this.dto.customName = ''
            this.dto.sendEmail = false
            let messageFilters = clone(this.dto)
            await this.$http.post(apiURI, messageFilters)
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.submitting = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      } else {
        let apiURI = this.$store.state.proposal.menu.export
        if (apiURI) {
          try {
            this.dto.propNo = this.propInfo.propNo
            this.dto.ipcNo = this.propInfo.ipcNo
            this.dto.ipcSeqNo = this.propInfo.ipcSeqNo
            this.dto.propType = this.propInfo.propType
            this.dto.format = 'PDF'
            this.dto.customName = ''
            this.dto.sendEmail = false
            let messageFilters = clone(this.dto)
            await this.$http.post(apiURI, messageFilters)
            this.doCancel()
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.submitting = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'propListing' })
    },
    doConvert() {
      this.resetMessages()
      this.$refs.proposalDetails.$validator.validateAll().then((result2) => {
        if (result2) {
          this.valConvert().then((result) => {
            if (result) {
              this.promptConvert = true
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async valConvert() {
      const apiUrl = this.$store.state.proposal.proposalDetails.menu.valPropPlan
      if (apiUrl) {
        try {
          this.submitMsg = 'Validating...'
          this.submitting = true

          let propPlan = this.$refs.proposalDetails.form.propPlan.split(',')
          const expand = {
            polType: propPlan[0],
            scheme: propPlan[1],
            planNo: propPlan[2]
          }
          await this.$http.get(expandURI(apiUrl, expand))

          this.submitting = false
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      return false
    },
    async proceedConvert() {
      this.convertForm.propNo = this.propInfo.propNo
      this.convertForm.ipcNo = this.propInfo.ipcNo
      this.convertForm.ipcSeqNo = this.propInfo.ipcSeqNo
      this.convertForm.propType = this.propInfo.propType
      let propPlan = this.$refs.proposalDetails.form.propPlan.split(',')
      this.convertForm.polType = propPlan[0]
      this.convertForm.scheme = propPlan[1]
      this.convertForm.planNo = propPlan[2]

      const apiURI = this.$store.state.proposal.menu.convert
      if (apiURI) {
        try {
          this.submitMsg = 'Processing...'
          this.submitting = true
          const result = await this.$http.post(apiURI, this.convertForm)
          const data = result.data
          let polNos = data.messages[0].message.split(',')
          this.polNo1 = polNos[0]
          this.polNo2 = polNos[1]
          this.submitting = false
          this.showInfoDialog = true
          // this.$toast.success('Proposal Conveted')
          // this.doCancel()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  components: {
    ProposalDetails,
    CoverageDetails
  },
  computed: {
    ...mapGetters(['checkAccess']),
    propInfo() {
      return this.$store.state.proposal.proposalDetails.propInfo
    },
    propMode() {
      return this.$store.state.proposal.proposalMode
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
